/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Use_3_ValueInputs */

const en_svc_rag_use_3_value = /** @type {(inputs: Svc_Rag_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accurate answers about products, terms and availability while the conversation is still warm.`)
};

const lv_svc_rag_use_3_value = /** @type {(inputs: Svc_Rag_Use_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precīzas atbildes par produktiem, noteikumiem un pieejamību, kamēr saruna vēl ir aktuāla.`)
};

/**
* | output |
* | --- |
* | "Accurate answers about products, terms and availability while the conversation is still warm." |
*
* @param {Svc_Rag_Use_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_use_3_value = /** @type {((inputs?: Svc_Rag_Use_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Use_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_use_3_value(inputs)
	return en_svc_rag_use_3_value(inputs)
});